
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import { BrandToaster } from './components/BrandToaster';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './components/AuthProvider';
import { SoundEffectsProvider } from './components/SoundEffectsProvider';
import { AchievementProvider } from './hooks/use-achievements';
import { ScrollToTop } from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import { VersionCheck } from './components/VersionCheck';
import './App.css';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30000,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ScrollToTop />
          <AuthProvider>
            <SoundEffectsProvider>
              <AchievementProvider>
                <Routes />
              </AchievementProvider>
            </SoundEffectsProvider>
          </AuthProvider>
        </BrowserRouter>
        <BrandToaster />
        <VersionCheck />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
